import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {Swatches} from '@Components/color-picker-v2/components/swatches';
import styles from './on-my-design-section.module.scss';
import type {RGBA} from '@Utils/color.util';
import {hexToRgba} from '@Utils/color.util';

interface OnMyDesignSectionProps {
  className?: string;
  colorsOnDesign: string[];

  onColorSelect(color: RGBA | string): void;

  isMobileVersion?: boolean;

  onClickAdd?(): void;

  isAlphaDisabled?: boolean;
}

export function OnMyDesignSection({
  isAlphaDisabled = false,
  className = '',
  onClickAdd = (): void => {},
  isMobileVersion = false,
  ...props
}: OnMyDesignSectionProps): ReactElement<any> | null {
  return (
    <div className={`flex-v-row ${isMobileVersion ? 'spacing-m-t-0' : 'spacing-m-t-6'} ${className}`}>
      <Text
        size={isMobileVersion ? TextSize.XXSMALL : TextSize.XSMALL}
        bold
        val={window.i18next.t('pmwjs_on_my_design')}
        className={`${isMobileVersion ? '' : styles.onMyDesignHeading} content-body`}
      />
      <Swatches
        onClick={(color: string): void => {
          props.onColorSelect(isAlphaDisabled ? color : hexToRgba(color));
        }}
        colors={props.colorsOnDesign}
        showAddButton={isMobileVersion}
        onClickAdd={onClickAdd}
        hasCustomMargins={isMobileVersion}
        className={isMobileVersion ? 'spacing-m-t-2' : ''}
      />
    </div>
  );
}
